import { get } from 'lodash-es';
import {
  SET_CAMPAIGN,
  SET_POST_DRAFTS,
  SET_VETTING_DATA,
  UPDATE_POST_DRAFT_ITEM,
  UPDATE_VETTING_DATA,
  UPDATE_VETTING_USER
} from '../actions/campaign.actions';

const initialState = {
  campaign: null,
  campaignId: null,
  offerId: null,
  vettingData: {
    vettingUsers: [],
    userOfferObjectAttributes: [],
    error: false,
    loading: true,
    hiredCounter: 0,
    backupCounter: 0,
    notSelectedCounter: 0,
    pendingCounter: 0,
    totalCounter: 0,
    filterBy: null,
    sortBy: null,
    update: null
  },
  drafts: [],
};

export default function campaignReducer(state = initialState, action) {
  let index = -1;
  let vettingUsers = [];
  let vettingData = null;
  switch (action.type) {
    case SET_CAMPAIGN:
      return {
        ...state,
        campaign: action.payload,
      };
    case SET_VETTING_DATA:
      return {
        ...state,
        vettingData: {
          ...state.vettingData,
          ...action.payload
        }
      };
    case UPDATE_VETTING_DATA:
      vettingData = state.vettingData;
      vettingData.update = Date.now();
      // vettingData.loading = true;
      return {
        ...state,
        vettingData: { ...vettingData }
      };
    case UPDATE_VETTING_USER:
      vettingUsers = get(state, 'vettingData.vettingUsers') || [];
      index = vettingUsers.findIndex(u => u.id === action.payload.userId);
      if (index !== -1) {
        const oldStatus = vettingUsers[index].vetting_status;
        const newStatus = action.payload.status;

        vettingUsers[index] = action.payload.user;
        let hiredCounter = state.vettingData.hiredCounter;
        let backupCounter = state.vettingData.backupCounter;
        let notSelectedCounter = state.vettingData.notSelectedCounter;
        let pendingCounter = state.vettingData.pendingCounter;

        hiredCounter = oldStatus === 'hired' ? hiredCounter - 1 : hiredCounter;
        backupCounter = oldStatus === 'backup' ? backupCounter - 1 : backupCounter;
        notSelectedCounter = oldStatus === 'fired' ? notSelectedCounter - 1 : notSelectedCounter;
        pendingCounter = oldStatus === 'pending' ? pendingCounter - 1 : pendingCounter;
        hiredCounter = newStatus === 'pass' ? hiredCounter + 1 : hiredCounter;
        backupCounter = newStatus === 'backup' ? backupCounter + 1 : backupCounter;
        notSelectedCounter = newStatus === 'fail' ? notSelectedCounter + 1 : notSelectedCounter;
        pendingCounter = newStatus === 'cancel' ? pendingCounter + 1 : pendingCounter;

        state.vettingData.hiredCounter = hiredCounter;
        state.vettingData.backupCounter = backupCounter;
        state.vettingData.notSelectedCounter = notSelectedCounter;
        state.vettingData.pendingCounter = pendingCounter;
        state.vettingData.vettingUsers = [...vettingUsers];

        return {
          ...state,
          vettingData: { ...state.vettingData },
        };
      }
      return state;

    case SET_POST_DRAFTS:
      return {
        ...state,
        drafts: action.payload,
      };
    case UPDATE_POST_DRAFT_ITEM:
      index = state.drafts.findIndex(u => u.id === action.payload.draftId);

      if (index !== -1) {
        state.drafts[index] = action.payload.item;
        return {
          ...state,
          drafts: [...state.drafts],
          draftsUpdated: Date.now()
        };
      }
      return state;
    default:
      return state;
  }
}

/**
 * @typedef {Object} Campaign
 * @property {number} id
 * @property {string} title
 *
**/